import { render, staticRenderFns } from "./AllegacyFooterCash.vue?vue&type=template&id=0fc5d719&scoped=true"
import script from "./AllegacyFooterCash.vue?vue&type=script&lang=ts"
export * from "./AllegacyFooterCash.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc5d719",
  null
  
)

export default component.exports